import { FansUnitedMarkets } from '../types';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default (sdk) => {
  function makeFootballPrediction({ matchId, market, value }: { value: string; matchId?: string; market?: FansUnitedMarkets }) {
    return sdk.predictor.makeFootballPrediction(matchId, market, value);
  }

  function getMyPredictionsForMatches({ matchId, predictionId }: { matchId: string; predictionId?: string }) {
    const filters = {
      limit: 1,
      startAfter: predictionId,
    };

    return sdk.predictor.getMyPredictionsForMatches([matchId], filters);
  }

  function getMarketSummary({ matchId, market }: { matchId: string; market?: FansUnitedMarkets }) {
    return sdk.predictor.getMarketSummary(matchId, market);
  }

  return { getMarketSummary, makeFootballPrediction, getMyPredictionsForMatches };
};
